import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useAvailableAiModels = (config) => {
  return useQuery({
    ...config,
    queryKey: "ai",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/ai-models`,
        signal,
      }),
  });
};
